import React from 'react'
import './Skills.css'
import techimg from './Skills-Icon/Head-Image.png'
import webdev from './Skills-Icon/web-development.png'
import prosol from './Skills-Icon/solved.png'
import program from './Skills-Icon/coding.png'
import tools from './Skills-Icon/github.png'
import framwork from './Skills-Icon/framework.png'
import kali from './Skills-Icon/kali.png'
import Fade from 'react-reveal/Fade';

const SkillArray = [
    {
        id: 200,
        simg: webdev,
        sheadp1: "Web Development",
        sheadp2: " ReactJs , NodeJs , Javascript , HTML , CSS , tailwind , PHP , Sql , Pl/Sql ",

    },
    {
        id: 201,
        simg: program,
        sheadp1: "Promming Languages",
        sheadp2: " (OOP) C++, (OOP) Java, Python",

    },
    {
        id: 202,
        simg: tools,
        sheadp1: "Tools & OS",
        sheadp2: "Vs Code, Eclipse, Github, Kali Linux, Windows, Virtual box",
    },
    {
        id: 203,
        simg: framwork,
        sheadp1: "FrameWorks & Libraries",
        sheadp2: "ReactJs, Bootstrap, SwiperJs, Java Swing, Nmap ",

    },
    {
        id: 204,
        simg: prosol,
        sheadp1: "Problem Solving",
        sheadp2: "Codechef, Hackerrank, GeeksforGeeks, LeetCode",

    },
    {
        id: 205,
        simg: kali,
        sheadp1: "Kali Linux Tools",
        sheadp2: "Maltego, Nmap, Harvestor, Sqlmap, SE Toolkit, MetaExploit",

    }
]


const Skills = () => {
    return (
        <>

            <section id="skills">


                <div className="img-head">
                    <span><img className='Tech_Image' src={techimg} alt='tech' /></span>
                    <span className="head-sec">Skills & Technologies</span>
                </div>


                <Fade bottom>
                    <div className="container-section">

                        {

                            SkillArray.map((ele) => {
                                return (
                                    <div className="skill-card" key={ele.id}  >
                                        <div className="image-card">
                                            <img src={ele.simg} alt="skills" className='Card_Image'></img>
                                        </div>
                                        <Fade bottom delay={500}>
                                            <div className="head-section">
                                                <p className='Edit-Color'>{ele.sheadp1}</p>
                                                <p className='Small-font-set'>{ele.sheadp2}</p>
                                            </div>
                                        </Fade>

                                    </div>
                                )
                            })
                        }


                    </div>
                </Fade>
            </section>

        </>
    )
}

export default Skills